export default () => ({
  memedSetupStatus: {
    error: null,
    loading: false
  },
  memedSetupFailed: false,
  memedToken: null
})
